const productGroupDimensionCategory = Object.freeze({
  Width: 'Width',
  Weight: 'Weight',
  Capacity: 'Capacity',
  Teeth: 'Teeth',
  Tines: 'Tines',
});

export { productGroupDimensionCategory };
